import { DEFAULT_TENANT_ID } from '@/constants/tenant'
import { TenantFromPrebuildFragment } from '@/generated/graphql'
import tenants from '@/generated/tenants.json'

export const getDefaultTenant = (): TenantFromPrebuildFragment => {
  return tenants.find((t) => t.id === DEFAULT_TENANT_ID) as TenantFromPrebuildFragment
}

const getCountryFromPath = (pathname: string): string | null => {
  const match = pathname.match(/^\/[a-z]{2}-([a-z]{2})/i)
  return match?.[1]?.toLowerCase() ?? null
}

export const getTenantFromCountry = (country: string): TenantFromPrebuildFragment | undefined => {
  return tenants.find((t) => t.countries.includes(country)) as
    | TenantFromPrebuildFragment
    | undefined
}

export const getTenantFromDomain = (domain: string): TenantFromPrebuildFragment | undefined => {
  if (domain.includes('localhost') || domain.includes('teamfeedr.vercel.app')) {
    if (typeof window !== 'undefined') {
      const country = getCountryFromPath(window.location.pathname)
      if (country) {
        const tenant = getTenantFromCountry(country)
        if (tenant) return tenant
      }
    }
    return getDefaultTenant()
  }

  return tenants.find((t) => t.domain === domain) as TenantFromPrebuildFragment | undefined
}

export const getTenantFromWindow = (): TenantFromPrebuildFragment | undefined => {
  return getTenantFromDomain(window.location.hostname)
}

export const getPageTenantSuffix = (page: string, domain: string): string => {
  const tenant = getTenantFromDomain(domain)

  const tenantName = tenant?.name

  let pageName = page
  if (tenantName) {
    pageName = `${page} | ${tenantName}`
  }

  return pageName
}

export const getTenantLinkComponentRule = (
  uri: string,
  domain: string,
  useRedirect = false,
  useRegex = true,
): { uri: string; displayComponent: boolean } => {
  const tenant = getTenantFromDomain(domain)

  const restriction = tenant?.uriRestrictedAccessRules.find((r) => {
    if (useRegex) return new RegExp(r.uri).test(uri)
    return r.uri.endsWith(uri)
  })

  if (!restriction) return { uri, displayComponent: true }

  if (restriction.redirectUri && useRedirect) {
    return { uri: restriction.redirectUri, displayComponent: true }
  }

  return { uri, displayComponent: false }
}
